export default "__VITE_ASSET__2161658c__"